import { createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../network/api";

const apiSlice = createSlice({
  name: "api",
  initialState: {
    // serverurl: 'http://backendcherryk.kwintechnologykw11.com:4000/api/',
    serverurl:
      API_URL,
  },
  reducers: {},
});

export const {} = apiSlice.actions;
export default apiSlice.reducer;
